import { useSelector } from 'react-redux';
import { selectPermissions, State } from '~/slices/ui';

function usePermissions(): State['permissions'];
// eslint-disable-next-line no-redeclare
function usePermissions(permission: string): boolean;
// eslint-disable-next-line no-redeclare
function usePermissions(permission?: string): any {
  const permissionsState = useSelector(selectPermissions);

  if (permission) {
    return permissionsState.permissions[permission];
  }
  return permissionsState;
}

export default usePermissions;
